import React, {FC} from 'react';
import styled from 'styled-components';

import {AsyncStatusesEnum} from '../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {AsyncLoader} from '../../../libs/shared/ui/src/components/loaders/asyncLoader';
import {center} from '../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface InboxesFailedProps {
  onRetryClick: () => void;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  background-color: ${(p) => p.theme.appBackground};
  ${center()};
`;

/*
 * Component.
 */

export const InboxesFailed: FC<InboxesFailedProps> = (props) => (
  <StyledDiv>
    <AsyncLoader
      status={AsyncStatusesEnum.FAILED}
      shouldHideRetryAfterReconnect
      onRetryClick={props.onRetryClick}
    />
  </StyledDiv>
);
